var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70605 0C4.50605 0 0.706055 3.22 0.706055 8.2C0.706055 11.38 3.15605 15.12 8.04605 19.43C8.42605 19.76 8.99605 19.76 9.37605 19.43C14.2561 15.12 16.7061 11.38 16.7061 8.2C16.7061 3.22 12.9061 0 8.70605 0ZM8.70605 10C7.60605 10 6.70605 9.1 6.70605 8C6.70605 6.9 7.60605 6 8.70605 6C9.80606 6 10.7061 6.9 10.7061 8C10.7061 9.1 9.80606 10 8.70605 10Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8abfed77cf79d5f241099bcc1abe0d67.svg";
export { ForwardRef as ReactComponent };